import $ from 'jquery';
import Mustache from 'mustache';

import { getBreakpoint } from './utils';

const siteQuickSearch = {

  init() {
    this.$el = {
      body: $('body'),
      header: $('header.header'),
      el: $('#site-quick-search'),
      form: $('[data-site-search-form]'),
      input: $('[data-site-search-form] [name="search"]'),
      results: $('#site-quick-search-results'),
      toggleButton: $('button[aria-controls="site-quick-search"]'),
      clearButton: $('[data-site-search-button="clear"]')
    };
    this.templates = {
      results: $('#template-site-search-results').html()
    };
    this.results = {
      term: '',
      page: 1,
      total_hits: 0,
      hits: []
    };
    this._scheduledRequest = null;
    this._request = null;
    this.animationDelay = 200;
    this.searchDelay = 500;
    this.minCharacters = 3;

    console.log('siteQuickSearch.init()');

    // Handle addsearch click event
    // Used in quick search and search page
    $(document).on('click', '[data-search-item] a', (e) => {
      const $el = $(e.currentTarget);
      const $item = $el.closest('[data-search-item]');

      // Send event if item has search result id and if clicked link matches result url
      if ($item.length > 0 && $item.data('search-item') && $item.data('search-item-url') === $el.attr('href')) {
        this.sendClickEvent({
          url: $el.attr('href'),
          id: $item.data('search-item'),
          position: $item.data('search-item-position'),
          term: $item.data('search-item-term'),
        });
        return false;
      }
    });

    if (this.$el.el.length === 0) {
      return;
    }

    this._addListeners();

    // Open search on page load if link uses special anchor
    if (window.location.hash === '#site-quick-search') {
      setTimeout(() => {
        this.open();
      }, 200);
    }

    if (this._alwaysOpen()) {
      this.open();
      this.$el.body.addClass('addsearch-always-open');
    }
  },

  _addListeners() {
    // Show/hide quick search
    this.$el.toggleButton.on('click', (e) => {
      const $target = $(e.currentTarget);
      if ($target.attr('aria-expanded') === 'false') {
        this.open();
        this.moveFocusTo('input');
      }
      else {
        this.close();
      }
    });

    // Empty search field and remove old results
    this.$el.clearButton.on('click', (e) => {
      this.$el.input.val('').trigger('value');
      this.results = {
        term: '',
        page: 1,
        total_hits: 0,
        hits: []
      };

      window.setTimeout(() => {
        this._renderResults();
        this.moveFocusTo('input');
      }, this.animationDelay);
    });

    // Handle search input events
    let oldValue = this.$el.input.val().trim();
    this.$el.input.on('value keyup', (e) => {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (this.isResultsOpen()) {
          this.hideResults();
        }
        else {
          this.showResults();
        }
      }
      else if (e.key === 'Escape') {
        this.close();
        this.moveFocusTo('toggle');
      }

      const value = this.$el.input.val().trim();
      if (oldValue === value) {
        return;
      }

      oldValue = value;
      this.search();
    });

    // Open search results on focus
    this.$el.input.on('focus', () => {
      if (this.results.total_hits > 0 && !this.isResultsOpen()) {
        this.showResults();
      }
    });

    // Close search results on escape
    this.$el.results.on('keyup', (e) => {
      if (e.key === 'Escape') {
        this.hideResults();
      }
    });

    // Close search when focus moves outside of search element
    this.$el.body.on('keyup', (e) => {
      if (e.key === 'Tab' && $(document.activeElement).closest(this.$el.el).length === 0) {
        this.close();
      }
    });

    // Close quick search when user clicks outside of search element
    this.$el.body.on('click', (e) => {
      const $target = $(e.target);
      if ($target.closest(this.$el.el).length === 0 && $target.closest(this.$el.toggleButton).length === 0) {
        this.close();
      }
    });

    // Rerender result view when breakpoint changes
    let lastBreakpoint = getBreakpoint();
    $(window).on('resize', () => {
      const breakpoint = getBreakpoint();
      if (lastBreakpoint !== breakpoint) {
        this._renderResults();
        lastBreakpoint = breakpoint;
      }
      if (this._alwaysOpen()) {
        this.open();
        this.$el.body.addClass('addsearch-always-open');
      }
      else {
        this.$el.body.removeClass('addsearch-always-open');
        const value = this.$el.input.val().trim();
        if (!value) {
          this.close();
        }
      }
    });
  },

  /**
   * Checks whether quick search is always open.
   *
   * @returns {Boolean}
   * @private
   */
  _alwaysOpen() {
    return this._isMobile();
  },

  /**
   * Checks whether current breakpoint is mobile breakpoint.
   *
   * @returns {Boolean}
   * @private
   */
  _isMobile() {
    return ['xs', 'sm'].indexOf(getBreakpoint()) > -1;
  },

  /**
   * Render results view with current results.
   * @private
   */
  _renderResults() {
    const results = { ...this.results };

    // Decrease mobile result amount
    if (this._isMobile()) {
      results.hits = results.hits.slice(0, 6);
    }

    this.$el.results.html(Mustache.render(this.templates.results, results));
  },

  /**
   * Checks if results are shown.
   *
   * @returns {Boolean}
   */
  isResultsOpen() {
    return this.$el.results.hasClass('open');
  },

  /**
   * Hides results.
   */
  hideResults() {
    if (!this._isMobile()) {
      this.moveFocusTo('input');
    }
    this.$el.results.slideUp(this.animationDelay).removeClass('open');
  },

  /**
   * Shows results.
   */
  showResults() {
    if (!this.results.term) {
      return;
    }
    this.$el.results.slideDown(this.animationDelay).addClass('open');
  },

  /**
   * Schedules search request.
   */
  search() {
    const value = this.$el.input.val().trim();

    // Add class to form when input value is not empty
    if (value.length > 0) {
      this.$el.form.addClass('has-value');
    }
    else {
      this.$el.form.removeClass('has-value');
    }

    // Cancel old timeout
    if (this._scheduledRequest) {
      window.clearTimeout(this._scheduledRequest);
      this._scheduledRequest = null;
    }

    // Search value is too short
    if (value.length < this.minCharacters) {
      if (!value) {
        this.hideResults();
      }
      return;
    }

    // Fetch results from server and rerender results view
    const fetchResults = () => {
      if (this._request) {
        this._request.abort();
      }
      this.$el.form.addClass('loading');
      this._request = $.ajax({
        url: '/stage-ajax/siteSearch/',
        data: {
          'stage-language': this.$el.form.data('lang'),
          site: this.$el.form.data('site'),
          search: this.$el.input.val()
        }
      }).always((response) => {
        this._request = null;
        this.$el.form.removeClass('loading');

        if (response.hits) {
          response.hits.forEach(hit => {
            hit.title = hit.title.replace(/®/g, '').replace(new RegExp(`(${response.term})`, 'i'), '<span class="search-highlight">$1</span>');
          });
          response.showAllResults = this.$el.form.attr('action') + '?search=' + response.term;

          this.results = response;

          this._renderResults();
          this.showResults();
        }
      });
    };

    this._scheduledRequest = setTimeout(fetchResults.bind(this), this.searchDelay);
  },

  /**
   * Checks if quick search is open.
   *
   * @returns {Boolean}
   */
  isOpen() {
    return this.$el.el.hasClass('open');
  },

  /**
   * Open quick search.
   */
  open() {
    this.$el.el.slideDown(this.animationDelay).addClass('open');
    this.$el.toggleButton.attr('aria-expanded', 'true');
    this.$el.header.addClass('hover');
  },

  /**
   * Close quick search. Note! If search is always visible, this hides results instead.
   */
  close() {
    if (this._alwaysOpen()) {
      this.hideResults();
      return;
    }

    this.$el.el.slideUp(this.animationDelay, () => {
      this.$el.header.removeClass('hover');
    }).removeClass('open');
    this.$el.toggleButton.attr('aria-expanded', 'false');
  },

  /**
   * Moves focus to first available input based on given type.
   *
   * @param {String} type input, toggle
   */
  moveFocusTo(type) {
    if (type === 'input') {
      this.$el.input.get(0).focus();
    }
    else if (type === 'toggle') {
      this.$el.toggleButton.get(0).focus();
    }
  },

  /**
   * Sends click event to addsearch.
   *
   * @param {Object} data Event data.
   */
  sendClickEvent(data) {
    if (this._processingClickEvent) {
      return;
    }

    this._processingClickEvent = data.id;

    let locationChanging = false;
    const loadTargetPath = () => {
      if (data.url && !locationChanging) {
        locationChanging = true;
        window.location = data.url;
      }
    };

    // Send click event to addsearch
    $.ajax({
      url: `/stage-ajax/siteSearch/?stage-language=${document.body.getAttribute('data-language')}&context=reportClick`,
      type: 'POST',
      data: {
        id: data.id,
        position: data.position,
        term: data.term
      }
    }).always(loadTargetPath);

    // Navigate to new url after small delay, even if ajax request has not completed
    setTimeout(loadTargetPath, 500);
  }
}

export default siteQuickSearch;
